import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "./images/dodologo2.JPG";

export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      
      if (href === "#") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const element = document.querySelector(href);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        }
      }
    }
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.navbar')) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="navbar-left">
        <div className="navbar-logo">
          <a href="/" aria-label="Dodo uređenje - Početna stranica">
            <img 
              src={logo} 
              alt="Dodo uređenje logo" 
              style={{ height: "40px", width: "auto" }} 
              loading="eager"
              width="40"
              height="40"
              fetchPriority="high"
            />
          </a>
        </div>
        <button
          className="navbar-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          aria-controls="navbar-menu"
        >
          ☰
        </button>
      </div>

      <ul 
        id="navbar-menu"
        className={`navbar-links${menuOpen ? " open" : ""}`}
        role="menubar"
      >
        <li role="none">
          <a 
            href="#" 
            onClick={(e) => handleLinkClick(e, "#")}
            role="menuitem"
          >
            Naslovnica
          </a>
        </li>
        <li role="none">
          <a 
            href="#cjenik" 
            onClick={(e) => handleLinkClick(e, "#cjenik")}
            role="menuitem"
          >
            Cjenik
          </a>
        </li>
        <li role="none">
          <a 
            href="#onama" 
            onClick={(e) => handleLinkClick(e, "#onama")}
            role="menuitem"
          >
            O nama
          </a>
        </li>
        <li role="none">
          <a 
            href="#usluge" 
            onClick={(e) => handleLinkClick(e, "#usluge")}
            role="menuitem"
          >
            Usluge
          </a>
        </li>
        <li role="none">
          <a 
            href="#kontakt" 
            onClick={(e) => handleLinkClick(e, "#kontakt")}
            role="menuitem"
          >
            Kontakt
          </a>
        </li>
        <li className="navbar-phone-item" role="none">
          <a 
            href="tel:0976069465" 
            className="navbar-phone"
            role="menuitem"
            aria-label="Pozovite nas na 097 606 9465"
          >
            📞 097 606 9465
          </a>
        </li>
      </ul>
    </nav>
  );
}
